import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Card, CardContent, Grid, Link, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { useContext, useMemo } from "react";
import UserGroupsContext from "../../contexts/data/UserGroupsContext";
import MapContext from "../../contexts/data/MapContext";
import { SpeciesContext } from "../../contexts/data/SpeciesContext";
import useQueryEmailNotificationConfig from "../../hooks/data/userQueryEmailNotificationConfig";
import { useParams } from "react-router-dom";
import { faEnvelope } from "@fortawesome/pro-duotone-svg-icons";
import { AppSettings } from "../../AppSettings";

const EmailNotificationCard = () => {

    //
    // -- Context --
    const { data: userGroupsConfig } = useContext(UserGroupsContext);
    const { filter } = useContext(MapContext);
    const { species } = useContext(SpeciesContext);

    // 
    // -- Params --
    const { species: speciesName } = useParams();

    // Generate the site events request
    const emailNofiticationRequest = useMemo(() => {
        return {
            speciesId: species.species,
            communityGroupId: filter.bySubmitter.communityGroupId
        };
    }, [userGroupsConfig, filter, species]);

    // Get the email notification request
    const { data: emailNotifications, loading: emailNotificationsLoading } = useQueryEmailNotificationConfig(
        emailNofiticationRequest, 
        { revalidateOnFocus: false, errorRetryCount: 0 }
    );
    
    return (
        <Card variant="outlined">
            <CardContent>
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center">
                            <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: '1.2rem', paddingRight: '5px' }} />
                            <Typography paddingLeft="5px" fontSize={24}>
                                Email Notifications
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center">
                            <Typography paddingLeft="5px" fontSize={16}>
                                The email notifications listed below are sent when members of your group submit a record.
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center">
                            <Typography paddingLeft="5px" fontSize={16}>
                                If you would like to request a new email alert for your group, please email <Link href={`mailto:${AppSettings.systemMailAddress}`}>{AppSettings.systemMailAddress}</Link>, and we will assist you.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{padding: '10px'}} />

                <Table>
                    <TableHead>
                        <TableRow sx={{backgroundColor: '#f0f0f0'}}>
                            <TableCell align="left">
                                <Typography fontSize={16} fontWeight={600}>
                                    Type
                                </Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography fontSize={16} fontWeight={600}>
                                    Name
                                </Typography>
                            </TableCell>
                            <TableCell align="left">
                                <Typography fontSize={16} fontWeight={600}>
                                    Region
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(!emailNotificationsLoading && emailNotifications && emailNotifications?.length > 0) && (
                            <>
                                {emailNotifications.map((notification, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {speciesName && userGroupsConfig?.sightingType?.find(
                                                sightingType => sightingType.sightingTypeId === notification.sightingTypeId)?.sightingTypeName != null
                                                ? `${userGroupsConfig?.sightingType?.find(
                                                    sightingType => sightingType.sightingTypeId === notification.sightingTypeId
                                                )?.sightingTypeName} ${speciesName.replace("scan", "").replace("alert", "").capitaliseFirstLetter()}` :
                                                "Unknown"
                                            }
                                        </TableCell>
                                        <TableCell>{notification.emailNotificationDescription}</TableCell>
                                        <TableCell>{notification.region?.name ?? 'N/A'}</TableCell>
                                    </TableRow>
                                ))}
                            </>
                        )}
                    </TableBody>
                </Table>
                {(!emailNotificationsLoading && emailNotifications && emailNotifications?.length === 0) && (
                    <Typography sx={{padding: '20px'}}>
                        No email notifications exist for this species and group.
                    </Typography>
                )}
            </CardContent>
        </Card>
    )
}

export default EmailNotificationCard